// Remove Batch Message Template
export const REMOVE_BATCH_MESSAGE_TEMPLATE_REQUEST = 'REMOVE_BATCH_MESSAGE_TEMPLATE_REQUEST';
export const REMOVE_BATCH_MESSAGE_TEMPLATE_DONE = 'REMOVE_BATCH_MESSAGE_TEMPLATE_DONE';
export const REMOVE_BATCH_MESSAGE_TEMPLATE_FAILED = 'REMOVE_BATCH_MESSAGE_TEMPLATE_FAILED';
